// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__D0iHl","sendOtp":"AuthorizeToLogin_sendOtp__s6qNr"};